import CssBaseline from "@mui/material/CssBaseline";
import "./App.css";
import Layout from "./core/components/Layout/Layout";

function App() {
  return (
    <>
      <CssBaseline />
      <Layout />
    </>
  );
}

export default App;
